import { CardMedia, Theme } from "@mui/material";
import { SxProps } from "@mui/system/styleFunctionSx";

import { IncidentFootage, IncidentFootageType } from "types/Incident";

export interface IncidentViewerFootageProps {
    footage: IncidentFootage;
    showControls?: boolean;
    sx?: SxProps<Theme>;
}

export function IncidentViewerFootage(props: IncidentViewerFootageProps) {
    return (
        <>
            {props.footage.footageType === IncidentFootageType.Image && (
                <CardMedia
                    component="img"
                    image={props.footage.fileName}
                    crossOrigin={"use-credentials"}
                    sx={[
                        {
                            objectFit: "contain",
                        },
                        ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
                    ]}
                />
            )}

            {props.footage.footageType === IncidentFootageType.Video && (
                <CardMedia
                    component="video"
                    src={props.footage.fileName}
                    crossOrigin={"use-credentials"}
                    autoPlay={true}
                    muted={true}
                    loop={true}
                    controls={props.showControls}
                    sx={[
                        {
                            objectFit: "contain",
                        },
                        ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
                    ]}
                />
            )}
        </>
    );
}
